import React from 'react';

import {
  LegacyText,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@gogame/components';
import { NumberValueFormatter } from '@gogame/intl-ts';

import BenchmarkTooltip from 'scenes/FinancialResults/components/BenchmarkTooltip';

const Stats = ({ stats = [], businessEntities }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Application</TableCell>
            <TableCell align={'right'}>Total ROAS D7</TableCell>
            <TableCell align={'right'}>CPI</TableCell>
            <TableCell align={'right'}>CVR</TableCell>
            <TableCell align={'right'}>Regs</TableCell>
            <TableCell align={'right'}>Spend</TableCell>
            <TableCell align={'right'} colSpan={3}>
              UA / RE / Total
              <br /> Installs By Post-Attr. Fraud
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stats.map((stat, i, stats) => {
            const textProps = {
              size: '13px',
              font: i === stats.length - 1 ? 'medium' : 'regular',
            };
            return (
              <TableRow key={i}>
                <TableCell>
                  <LegacyText {...textProps}>
                    {stat.application.name}
                  </LegacyText>
                </TableCell>
                <TableCell>
                  <Stack justifyContent={'flex-end'} direction={'row'}>
                    <BenchmarkTooltip
                      {...stat.applicationBenchmark}
                      businessEntities={businessEntities}
                    >
                      <LegacyText {...textProps}>
                        <NumberValueFormatter.Percent value={stat.roasD7} />
                      </LegacyText>
                    </BenchmarkTooltip>
                  </Stack>
                </TableCell>
                <TableCell align={'right'}>
                  <LegacyText {...textProps}>
                    <NumberValueFormatter.Currency
                      value={stat.cpi.amount}
                      currency={stat.cpi.currencyCode}
                    />
                  </LegacyText>
                </TableCell>
                <TableCell align={'right'}>
                  <LegacyText {...textProps}>
                    <NumberValueFormatter.Percent value={stat.cvr} />
                  </LegacyText>
                </TableCell>
                <TableCell align={'right'}>
                  <LegacyText {...textProps}>{stat.regs}</LegacyText>
                </TableCell>
                <TableCell align={'right'}>
                  <Stack justifyContent={'flex-end'} direction={'row'}>
                    <LegacyText {...textProps}>
                      <NumberValueFormatter.Currency
                        value={stat.spending.amount}
                        curreny={stat.spending.currencyCode}
                      />
                    </LegacyText>
                  </Stack>
                </TableCell>
                <TableCell align={'right'} style={{ paddingLeft: '20px' }}>
                  <NumberValueFormatter.Decimal
                    value={stat.uaRejectedInstallsByPostAttributionFraud}
                  />
                </TableCell>
                <TableCell align={'right'}>
                  <NumberValueFormatter.Decimal
                    value={stat.reRejectedInstallsByPostAttributionFraud}
                  />
                </TableCell>
                <TableCell align={'right'}>
                  <NumberValueFormatter.Decimal
                    value={stat.totalRejectedInstallsByPostAttributionFraud}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Stats;
